import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the Nl2BrPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'nl2Br',
})
export class Nl2BrPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    if(value.indexOf('<br') > -1) {
      return value;
    }
    return (value?value:'').replace("\n", "<br /><br />");
  }
}



// WEBPACK FOOTER //
// ./src/pipes/nl2-br/nl2-br.ts